import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { isTrue } from '../form-controls.util';

@Component({
  selector: 'custom-dropdown',
  templateUrl: './custom-dropdown.component.html',
  styleUrls: ['./custom-dropdown.component.scss']
})
export class CustomDropdownComponent implements OnInit {
  /**
   * 
   */
  @Input()
  set inline(v: boolean) {
    this.isInline = isTrue(v);
  }
  /**
   * 
   */
  @Input()
  label: string;
  /**
   * 
   */
  @Input()
  value: any;
  /**
   * 
   */
  @Input()
  data: any[];
  /**
   * 
   */
  @Input()
  set disabled(v: boolean) {
    this.isDisabled = isTrue(v);
  }
  /**
   * 
   */
  @Input()
  textField: string;
  /**
   * 
   */
  @Input()
  valueField: string

  /**
   * 
   */
  @Output()
  selectionChange: EventEmitter<any> = new EventEmitter<any>();

  isInline = false;
  isDisabled = false;

  constructor() { }

  ngOnInit() {
  }

  onChange(v) {
    this.selectionChange.emit(v);
  }

  getValue(item) {
    if (item && this.valueField && item.hasOwnProperty(this.valueField)) {
      return item[this.valueField];
    }
    return item;
  }

  getText(item) {
    if (item && this.textField && item.hasOwnProperty(this.textField)) {
      return item[this.textField];
    }
    return item;
  }

}
